// import { Link } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import React, { Component } from "react";
import { getInspection } from "../../graphql/queries";
import gql from "graphql-tag";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { spinnerService } from "@chevtek/react-spinners";

import {
  Label,
  Button as Btn,
  Container,
  Row,
  Col
} from "reactstrap";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { styles } from '../../assets/css/styles'

class InspectionDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inspectionData: [],
      type: null,
      open: false
    };
  }
  notify = msg => toast(msg);
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  cancelForm = () => this.props.history.goBack();

  loadInspection = async id => {
    spinnerService.show("mySpinner");
    const { client } = this.props;
    const inspection = await client.query({
      query: gql(getInspection),
      fetchPolicy: `network-only`,
      variables: { id }
    });
    this.setState({ inspectionData: inspection.data.getInspection });
    spinnerService.hide("mySpinner");
  };
  fetchFromStore = id => {
    this.props.data.inspections.map(Item => {
      if (Item.id === id) {
        this.setState({ inspectionData: Item });
      }
    });
  };
  async componentDidMount() {
    if (this.props.data === undefined || this.props.data.length == 0) {
      await this.loadInspection(this.props.match.params.iId);
    } else {
      this.fetchFromStore(this.props.match.params.iId);
      await true;
    }
  }
  render() {
    return (
      <div>
        <div>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {this.state.type === "inspector"
                ? "Inspector"
                : this.state.type === "observation"
                  ? "Observation"
                  : this.state.type === "defects"
                    ? "Defects"
                    : null}
              {" Details"}
            </DialogTitle>
            <DialogContent>
              {this.state.type === "inspector" ? (
                <DialogContentText id="alert-dialog-description">
                  <p>
                    Name:{" "}
                    {this.state.inspectionData.length !== 0
                      ? this.state.inspectionData.inspector.name
                      : null}
                  </p>
                  <p>
                    Address:{" "}
                    {this.state.inspectionData.length !== 0
                      ? this.state.inspectionData.inspector.homeAddress
                      : null}
                  </p>
                </DialogContentText>
              ) : null}
              {this.state.type === "observation" ? (
                <DialogContentText id="alert-dialog-description">
                  {this.state.inspectionData.length !== 0 &&
                    this.state.inspectionData.inspectionObservations !== null
                    ? this.state.inspectionData.inspectionObservations.map(
                      (obj, key) => {
                        return <p key={key}>{obj}</p>;
                      }
                    )
                    : "No Observations"}
                </DialogContentText>
              ) : null}
              {this.state.type === "defects" ? (
                <DialogContentText id="alert-dialog-description">
                  {this.state.inspectionData.length !== 0 &&
                    this.state.inspectionData.inspectionDefects !== null
                    ? this.state.inspectionData.inspectionDefects.map(
                      (obj, key) => {
                        return (
                          <div key={key}>
                            <p>Name: {" " + obj.__typename}</p>
                            <p>Type: {" " + obj.defectType}</p>
                            <p>Desc: {" " + obj.defectDesc}</p>
                          </div>
                        );
                      }
                    )
                    : "No Defects"}
                </DialogContentText>
              ) : null}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <main ref="main" App>
          <section className="section section-shaped section-lg">
            <Container className="pt-lg-sm pt-2">
              <Row className="justify-content-left">
                <Col lg={12}>
                  <Card style={{ height: "350px" }}>
                    <CardHeader color="primary">
                      <h4 className={styles.cardTitleWhite}>
                        Inspection Details
                      </h4>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col xs="6">
                          <Label
                            for="exampleEmail"
                            className="mr-sm-4"
                            size="md"
                          >
                            Customer Vehicle Id:{"  "}
                          </Label>
                          <Label
                            for="exampleEmail"
                            className="mr-sm-4"
                            size="md"
                          >
                            {this.state.inspectionData.length !== 0
                              ? this.state.inspectionData.vehicle
                                .customerVehicleId
                              : null}
                          </Label>
                        </Col>
                        <Col xs="6">
                          <Label
                            for="exampleEmail"
                            className="mr-sm-4"
                            size="md"
                          >
                            CalBit Id:{"  "}
                          </Label>
                          <Label
                            for="exampleEmail"
                            className="mr-sm-4"
                            size="md"
                          >
                            {this.state.inspectionData.length !== 0
                              ? this.state.inspectionData.vehicle.id
                              : null}
                          </Label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="6">
                          <Label
                            for="exampleEmail"
                            className="mr-sm-4"
                            size="md"
                          >
                            Inspection Type:{"  "}
                          </Label>
                          <Label
                            for="exampleEmail"
                            className="mr-sm-4"
                            size="md"
                          >
                            {this.state.inspectionData.length !== 0
                              ? this.state.inspectionData.inspectionType
                              : null}
                          </Label>
                        </Col>
                        <Col xs="6">
                          <Label
                            for="exampleEmail"
                            className="mr-sm-4"
                            size="md"
                          >
                            Inspection Date:{"  "}
                          </Label>
                          <Label
                            for="exampleEmail"
                            className="mr-sm-4"
                            size="md"
                          >
                            {this.state.inspectionData.length !== 0
                              ? this.state.inspectionData.startAt
                              : null}
                          </Label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="6">
                          <Label
                            for="exampleEmail"
                            className="mr-sm-4"
                            size="md"
                          >
                            Status:{"  "}
                          </Label>
                          <Label className="mr-sm-4">
                            {this.state.inspectionData.length !== 0
                              ? this.state.inspectionData.inspectionStatus
                              : null}
                          </Label>
                        </Col>
                        <Col xs="6">
                          <Label
                            for="exampleEmail"
                            className="mr-sm-4"
                            size="md"
                          >
                            Next Inspection Due:{"  "}
                          </Label>
                          <Label className="mr-sm-4">
                            {this.state.inspectionData.length !== 0
                              ? this.state.inspectionData.nextInspectionDue
                              : null}
                          </Label>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "30px" }}>
                        <Col xs="8">
                          <Btn
                            onClick={() =>
                              this.setState({ type: "inspector", open: true })
                            }
                            color="primary"
                            size="sm"
                          >
                            Inspector
                          </Btn>
                          {"   "}
                          <Btn
                            onClick={() =>
                              this.setState({ type: "defects", open: true })
                            }
                            color="primary"
                            size="sm"
                          >
                            Defects
                          </Btn>
                          {"   "}
                          <Btn
                            onClick={() =>
                              this.setState({ type: "observation", open: true })
                            }
                            color="primary"
                            size="sm"
                          >
                            Observation
                          </Btn>
                        </Col>
                      </Row>
                      <br />
                      <div className="text-center">
                        <Row lg="12" className="px-3 ">
                          <Col></Col>
                          <Col>
                            <Btn
                              className=" btn-lg btn-block mt-2"
                              color="default"
                              onClick={() => this.cancelForm()}
                            >Back</Btn>
                          </Col>
                          <Col></Col>
                        </Row>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.inspections.loading,
    data: state.inspections.data,
    client: state.config.client
  };
};
export default InspectionDetail = connect(mapStateToProps)(
  withStyles(styles)(InspectionDetail)
);



// WEBPACK FOOTER //
// ./src/views/Inspections/InspectionDetail.jsx